/* ==========================================================================
  front-end.js
========================================================================== */

"use strict";

let currentLang = rtc_params.lang || "fi";

function playDoorbellSound() {
    const audio = document.getElementById("rtc-doorbell");
    if (audio) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
    }
}

function toggleChatWrapper() {
    const wrapper = document.getElementById("rtc-wrapper");
    if (!wrapper) return;
    if (wrapper.classList.contains("is-hidden")) {
        wrapper.classList.remove("is-hidden");
        playDoorbellSound();
    } else {
        wrapper.classList.add("is-hidden");
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector("#rtc-wrapper");
    if (!wrapper) return;

    const input = wrapper.querySelector(".rtc-input");
    const send = wrapper.querySelector(".rtc-send");
    const messages = wrapper.querySelector(".rtc_messages");
    const welcome = wrapper.querySelector(".rtc_welcome");
    const footer = wrapper.querySelector(".rtc_footer");
    const langSelect = wrapper.querySelector(".rtc_lang_select");

    function formatBotMessage(text) {
        return text
            .replace(
                /\[suggestion\](.*?)\[\/suggestion\]/g,
                '<button class="rtc-suggestion" data-message="$1">$1</button>',
            )
            .replace(/\n/g, "<br>");
    }

    function setLanguage(l) {
        currentLang = l;
        if (rtc_params.welcomes[l])
            welcome.innerHTML = rtc_params.welcomes[l].replace(/\n/g, "<br>");
        if (footer && rtc_params.disclaimers[l])
            footer.innerHTML = rtc_params.disclaimers[l];
        if (input && rtc_params.placeholders[l])
            input.placeholder = rtc_params.placeholders[l];
        if (langSelect) langSelect.value = l;
    }

    setLanguage(currentLang);

    wrapper.querySelectorAll(".rtc-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
            wrapper
                .querySelectorAll(".rtc-btn")
                .forEach((b) => b.classList.remove("active"));
            btn.classList.add("active");
            setLanguage(btn.dataset.lang);
        });
    });

    function appendMessage(role, text) {
        const div = document.createElement("div");
        div.className = "rtc_msg " + (role === "user" ? "rtc_user" : "rtc_bot");
        div.innerHTML =
            role === "bot" ? formatBotMessage(text) : text.replace(/\n/g, "<br>");
        messages.appendChild(div);
        setTimeout(() => (messages.scrollTop = messages.scrollHeight), 10);
    }

    const sendMessage = (message = null) => {
        const q = (message ?? input.value).trim();
        if (!q) return;
        appendMessage("user", q);
        input.value = "";
        appendMessage("bot", "<em>...</em>");

        fetch(rtc_params.rest_url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ query: q, lang: currentLang }),
        })
            .then((res) => res.json())
            .then((data) => {
                const bots = messages.querySelectorAll(".rtc_bot");
                if (bots.length) {
                    bots[bots.length - 1].innerHTML = formatBotMessage(
                        data.answer || rtc_params.empty_msg,
                    );
                }
            })
            .catch(() => {
                const bots = messages.querySelectorAll(".rtc_bot");
                if (bots.length) {
                    bots[bots.length - 1].innerHTML = rtc_params.error_msg;
                }
            });
    };

    send.addEventListener("click", () => sendMessage());
    input.addEventListener("keypress", (e) => {
        if (e.key === "Enter") sendMessage();
    });
    document.addEventListener("click", (e) => {
        if (!e.target.classList.contains("rtc-suggestion")) {
            return;
        }

        sendMessage(e.target.dataset.message);
    });

    // Toggle Logic
    document
        .getElementById("rtc-fab")
        ?.addEventListener("click", toggleChatWrapper);
    wrapper.querySelector(".rtc_close")?.addEventListener("click", () => {
        wrapper.classList.add("is-hidden");
    });

    // Preview Logic
    const preview = document.getElementById("rtc-preview");
    if (preview && !localStorage.getItem("rtcPreviewSeen")) {
        preview.classList.remove("is-hidden");
        localStorage.setItem("rtcPreviewSeen", "1");
    }

    document.querySelectorAll(".rtc-preview-close").forEach((btn) => {
        btn.addEventListener("click", () => {
            preview?.classList.add("is-hidden");
        });
    });
});
